import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, ButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import qs from 'qs';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';
import ViewStaff from './components/ViewStaff';
import ViewUser from './components/ViewUser';

const View = ({ error, access, open, type, item, languages, isLoading, isLoadingSubmit, onSubmit, onReset, onHide, fetchPreview }) => {
  const formNode = useRef(null);
  const [isSuperAdminEdit, setSuperAdminEdit] = useState(false);

  useEffect(() => () => setSuperAdminEdit(false), [open])

  const createStaffPayload = () => {
    const current = formNode?.current;
    const data = new FormData(current);
    const payload = {};
    for (const name of data.keys()) {
      if (formNode.current?.[name]) {
        payload[name] = formNode.current[name].value;
      }
    }
    return qs.parse(payload);
  }

  const createUserPayload = () => {
    const current = formNode?.current;
    const data = new FormData(current);
    const subjectNode = document.getElementById('notification-subject');
    const previewNode = document.getElementById('notification-preview');

    return {
      subject: subjectNode?.textContent || '',
      body: previewNode.children[0].outerHTML,
      language_code: data.get('language_code'),
    };
  }

  const onSubmitForm = (event) => {
    event?.preventDefault();
    const payload = type === 'view-user' ? createUserPayload() : createStaffPayload();
    onSubmit?.(item?.mode, payload);
  };

  const onResetForm = () => {
    const current = formNode?.current;
    const data = new FormData(current);
    const payload = {};

    if (type === 'view-user') {
      payload.language_code = data.get('language_code');
    }

    onReset(payload)
  }

  return (
    <Modal show={open} onHide={onHide} backdrop="static">
      <form ref={formNode} onSubmit={onSubmitForm}>
        <Modal.Header closeButton>
          <Modal.Title>View notification</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: isLoading ? '150px' : 'auto' }}>
          {isLoading && <div className="modal-loader-small" />}
          {error && <Alert text={error} />}
          {type === 'view-user' && item?.preview ? <ViewUser item={item} languages={languages} fetchPreview={fetchPreview} isSuperAdminEdit={isSuperAdminEdit} /> : null}
          {type === 'view-staff' ? <ViewStaff access={access} item={item} /> : null }
          {(type === 'view-staff' && access?.notifications_reset) || (isSuperAdminEdit && type === 'view-user')
            ? (
              <ButtonGroup>
                <Button onClick={onResetForm} disabled={!item?.access?.can_reset}>
                  Reset
                </Button>
              </ButtonGroup>
            ) : null}
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          {!isSuperAdminEdit && !isLoading && access?.notifications_edit && type === 'view-user'
            ? (
              <Button
                type="button"
                disabled={!item?.access?.can_edit}
                onClick={() => setSuperAdminEdit(true)}
              >
                Edit
              </Button>
            ) : null}
          {(access?.notifications_edit && item?.access?.can_edit && type === 'view-staff') || (access?.notifications_edit && isSuperAdminEdit && type === 'view-user') ? (
            <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading} onClick={onSubmitForm}>
              {isLoadingSubmit && <Spinner />}
              <span>Save changes</span>
            </Button>
          ) : null}
          <Button
            type="button"
            onClick={() => {
              onHide();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

View.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  access: PropTypes.object,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  languages: PropTypes.array,
  onHide: PropTypes.func,
  onReset: PropTypes.func,
  onSubmit: PropTypes.func,
  fetchPreview: PropTypes.func,
};

export default View;
